import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

export default function TextContentInfo({ text }) {
  const location = useLocation();
  return (
    <Box
      text={text}
      sx={{
        marginLeft: location.pathname.includes("detailedresults")
          ? null
          : "10%",
        "@media (max-width: 960px)": {
          fontSize: "12px",
        },
      }}
    >
      <Typography
        variant="h5"
        sx={{
          marginBottom: "10px",
          "@media (max-width: 960px)": {
            marginTop: "3px",
            marginBottom: "5px",
            fontSize: "1rem",
          },
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
